// Array of distinct colors that work well in both light and dark modes
const CALENDAR_COLORS = [
  '#3B82F6', // Blue
  '#EF4444', // Red
  '#10B981', // Emerald
  '#F59E0B', // Amber
  '#8B5CF6', // Violet
  '#EC4899', // Pink
  '#06B6D4', // Cyan
  '#F97316', // Orange
  '#84CC16', // Lime
  '#6366F1', // Indigo
  '#14B8A6', // Teal
  '#F43F5E', // Rose
  '#8B5A2B', // Brown
  '#64748B', // Slate
  '#7C3AED', // Purple
  '#DC2626', // Red (darker)
  '#059669', // Green (darker)
  '#D97706', // Orange (darker)
  '#7C2D12', // Red-brown
  '#374151', // Gray-dark
  '#1E40AF', // Blue (darker)
  '#BE185D', // Pink (darker)
  '#0E7490', // Cyan (darker)
  '#9333EA', // Purple (different)
  '#15803D', // Green (different)
  '#C2410C', // Orange (different)
  '#4338CA', // Indigo (different)
  '#0F766E', // Teal (different)
  '#A21CAF', // Fuchsia
  '#7E22CE', // Violet (different)
];

const GRAY_COLOR = '#6B7280'; // Medium gray that works in both light and dark modes

/**
 * Simple hash function to generate an integer from a string
 */
function simpleHash(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  return Math.abs(hash);
}

/**
 * Generate a deterministic calendar event color from a message id.
 * This is the single source of truth for event border colors across the app.
 */
export function getCalendarEventColor(messageId?: string | null): string {
  if (!messageId) {
    return GRAY_COLOR;
  }

  const hash = simpleHash(messageId);
  const colorIndex = hash % CALENDAR_COLORS.length;
  return CALENDAR_COLORS[colorIndex];
}